<template>
	<div class="load-sales-app">
		<van-row>
			<van-col span="24" class="content">
				<img src="../../assets/common/downLoad.png" />
			</van-col>
			<van-col span="24" class="btn">
				<span @click="downLoad">立即下载客户端</span>
			</van-col>
			<van-col span="24" class="instructions">
				<p class="title"><span class="left"></span>下载须知<span class="right"></span></p>
				
				<p class="item-title"><span></span>选择开店类型</p>
				<div class="item-content">您在销巴生活APP内完成实名认证后，即可申请创建个人店铺，并根据实际情况选择线上店铺或线下店铺，或者同时开通两种类型的店铺。</div>
				
				<p class="item-title"><span></span>阅读开店须知</p>
				<div class="item-content">
					<p class="step">（1）我可以开设多个店铺吗？可以。同一会员开设的多个店铺须分别与相关营业执照、法人证件保持一致，且确保经营范围合规。</p>
					<p>（2）我已经开过销巴店铺，现在想要注销原来的店铺重新开店，可以吗?满足条件就可以注销。重新开店请参考开店流程。</p>
				</div>
				
				<p class="item-title"><span></span>准备开店资料</p>
				<div class="item-content">请提前准备好您的店铺名称、营业执照、法人身份证及其他必需的各类证件资质，以便于快速通过开店审核，及早成为销巴商家。</div>
				
				<p class="item-title item-last"><span></span>温馨提示</p>
				<div class="item-content">为更好地获得店铺成长指导、商友互助合作与广告曝光扶持，您可以添加销巴生活官方运营助理“小巴同学”<span>（微信号：xbsh011）</span>，受邀加入销巴生活商家专属服务群和新商家成长圈。</div>
				
			</van-col>
			
		</van-row>
	</div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  created(){
  	
  },
  methods: {
	  downLoad() {
		  this.params('', '', 'downLoad');
	  }
  }
};
</script>
<style lang="less">
.load-sales-app {
	background: #FFFFFF;
	min-height: 100%;
	.content{
		background: #FFFFFF;
		img{
			width: 100%;
			display: block;
		}
	}
	.btn {
		padding: 0 20px;
		margin: 30px 0;
		span {
			display: inline-block;
			width: 100%;
			height: 50px;
			line-height: 50px;
			border-radius: 25px;
			background: #3E5995;
			color: #FFFFFF;
			font-weight: 18px;
			text-align: center;
			font-weight: bold;		
		}
	}
	.instructions {
		.title {
			text-align: center;
			color: #333;
			font-size: 18px;
			height: 25px;
			line-height: 25px;
			margin-bottom: 20px;
			font-weight: bold;
			.left {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 5px;
				background: #FDD872;
				margin-right: 8px;
			}
			.right {
				display: inline-block;
				width: 10px;
				height: 10px;
				border-radius: 5px;
				background: #8CD7F5;
				margin-left: 8px;
			}
		}
		.item-title {
			color: #333;
			font-size: 15px;
			height: 21px;
			line-height: 21px;
			padding: 0 17px 0 20px;
			margin-bottom: 8px;
			span {
				display: block;
				width: 6px;
				height: 6px;
				border-radius: 3px;
				background: #F5C4C4;
				margin-right: 10px;
			    float: left;
			    margin-top: 8px;
			}
		}
		.item-last {
			span {
				background: #FDD872;
			}
		}
		.item-content {
			color: #999;
			font-size: 14px;
			line-height: 24px;
			padding: 0 17px 0 20px;
			padding-bottom: 30px;
			.step {
				margin-bottom: 10px;
			}
			span {
				color: #3E5995;
				font-size: 14px;
				font-weight: bold;
			}
		}
	}
}

</style>
